<template>
    <div>
        <div v-if="!loading">
            <div class="text-center mb-4">
                <h2>Messages Count In Group</h2>
            </div>
            <div>
                <Bar :chart-options="chartOptions" :chart-data="chartData" :chart-id="chartId"
                    :dataset-id-key="datasetIdKey" :plugins="plugins" :css-classes="cssClasses" :styles="styles"
                    :width="width" :height="height" />
            </div>
            <div>
                <v-pagination v-if="showPagination" class="py-5 mt-5" v-model="page" :length="totalPages"
                    :total-visible="7"></v-pagination>
            </div>
        </div>
        <div v-else class="text-center">
            <v-progress-circular :size="100" color="#f87979" indeterminate></v-progress-circular>
        </div>
    </div>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'
import { mapActions } from "vuex";
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    name: 'MessagesInGroup',
    components: {
        Bar,
    },
    watch: {
        page: {
            handler(value) {
                this._getMessagesCountInGroup({ $limit: 5, $skip: (value - 1) * 5 })
            },
        },
        filterWhere: {
            deep: true,
            handler(value) {
                this.filters.$where = value
                this._getMessagesCountInGroup()
            },
        }
    },
    created() {
        this._getMessagesCountInGroup()
    },
    props: {
        filterWhere: {
            type: Object,
            default: () => { }
        },
        chartId: {
            type: String,
            default: 'bar-chart'
        },
        datasetIdKey: {
            type: String,
            default: 'label'
        },
        width: {
            type: Number,
            default: 400
        },
        height: {
            type: Number,
            default: 400
        },
        cssClasses: {
            default: 'text-center mb-10',
            type: String
        },
        styles: {
            type: Object,
            default: () => { }
        },
        plugins: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            filters: { $where: {} },
            loading: false,
            totalPages: 0,
            page: 1,
            showPagination: false,
            chartData: {
                labels: [],
                datasets: [
                    {
                        label: 'Messages Count in Group',
                        backgroundColor: '#f87979',
                        data: [],
                        barThickness: 20,
                        base: 0,
                    }
                ]
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
            },

        }
    },

    methods: {
        _getMessagesCountInGroup(params = { $limit: 5, $skip: 0 }) {
            this.loading = true
            params = { ...params, ...this.defaultSorting, ...this.filters }
            this.getMessagesCountInGroup(params).then((res) => {
                let meta = res.meta
                if (meta.count > 5) this.showPagination = true
                res = res.records
                this.totalPages = Math.ceil(meta.count / meta.limit);
                let groupNames = res.map(x => `${x.group_name}-${x.academy_name}`)
                let messagesCount = res.map(x => x.messages)

                this.chartData.labels = groupNames
                this.chartData.datasets[0].data = messagesCount
                this.loading = false

            }).catch(() => this.loading = false)
        },

        ...mapActions(["getMessagesCountInGroup"]),
    }
}
</script>
